import CenterMessage from "./CenterMessage";

export default function Empty() {
  return <CenterMessage message="No publications available at the moment." />;
}
